import React, { useContext, useEffect, useRef, useState } from "react";
import { LoginBox } from "./LoginBox";
import { Link, withRouter } from "react-router-dom";
import { Spin } from "../core/views/Spin";
import { SimpleFormView } from "../core/views/UForm";
import { GlobalContext } from "../GlobalContext";
import { Button } from "../core/views/Button";
import Box from "@mui/material/Box";
import { UFormField } from "../core/views/UFormField";
import { FormFields } from "../core/api/contracts/FormFields";
import { useRouteMatch } from "react-router";
import { BaseFormWithArrayFields } from "../core/BaseForm";
import { observer } from "mobx-react-lite";
import { useLoginStateProvider } from "../LoginStateProvider";

const formConfig = new FormFields()
  .addField("email", "required|email", "Email", "static", null, null, null, true)
  .addField("password", "required|min:6", "Password", "password")
  .addField("confirmPassword", "required|same:password", "Repeat Password", "password");

type NewPasswordForm = { email: string; password: string };

const ResetPasswordView = observer(() => {
  const context = useContext(GlobalContext);
  const [formValues, resetPasswordValues] = useState<NewPasswordForm>(null);
  const [form, setFormConfig] = useState<BaseFormWithArrayFields>();
  const [notFound, setNotFound] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const loginState = useLoginStateProvider();
  const {
    params: { id },
  } = useRouteMatch<{ id: string }>();

  useEffect(() => {
    // this is needed since the main view reload during login and this component can be recreated before the navigation
    // to the post-login route happens
    if (!context.auth.authentication.authenticated && !context.auth.authentication.loading) {
      context.usersStore
        .resetPasswordDetails(id, () => setNotFound(true))
        .then((userInfo) => {
          if (userInfo?.email) {
            const form = formConfig.createForm();
            form.$("email").sync(userInfo.email);
            setFormConfig(form);
          }
        });
    }
  }, [id, context.auth.authentication.authenticated]);

  useEffect(() => {
    const submit = async (values: NewPasswordForm) => {
      try {
        await context.usersStore.resetPassword(values.email, id, values.password);
        const reply = await context.auth.authMethodLogin(values, "upsolver");
        await loginState.handleLoginReply(reply);
      } catch {
        setSubmitting(false);
      }
    };
    if (formValues) {
      setSubmitting(true);
      submit(formValues);
    }
  }, [formValues]);

  const loading = !form && !notFound;
  return (
    <LoginBox
      footer={
        <p>
          <Link to="/login">Log In</Link> if you remember your password
        </p>
      }
    >
      <h1>Reset Password</h1>
      <Spin spinning={loading}>
        {!loading && (
          <div className="create-feature-form">
            {notFound ? (
              <p>The reset password link is either invalid or expired.</p>
            ) : (
              <SimpleFormView form={form} onSuccess={resetPasswordValues} disabled={submitting}>
                <div className="form-input-group">
                  <UFormField input={form.$("email")} />
                </div>

                <div className="form-input-group">
                  <UFormField input={form.$("password")} />
                  <UFormField input={form.$("confirmPassword")} />
                </div>

                <Box width="100%" textAlign="center" mt={3}>
                  <Button type="submit">Reset</Button>
                </Box>
              </SimpleFormView>
            )}
          </div>
        )}
      </Spin>
    </LoginBox>
  );
});
export default withRouter(ResetPasswordView);
